import type { FC } from 'react'
import { memo } from 'react'

import CueItem from '../../../components/rundown/CueItem'
import { CueProvider } from './cue-provider'

type CueProps = {
  cueId: string
}

export const Cue: FC<CueProps> = memo(function Cue({ cueId }) {
  return (
    <CueProvider cueId={cueId}>
      <CueItem key={cueId} />
    </CueProvider>
  )
})
